import '.ap{position:relative;}.ssr-plugin'
import '.l{width:100%;}.ssr-plugin'
import '.ha{min-height:200px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.ae{justify-content:center;}.ssr-plugin'
import '.am{align-items:flex-start;}.ssr-plugin'
import '.e5{padding:2rem;}.ssr-plugin'
import '.dm{background:var(--palette-white);}.ssr-plugin'
import '.b5{overflow:hidden;}.ssr-plugin'
import '.b8{position:absolute;}.ssr-plugin'
import '.jp{top:50%;}.ssr-plugin'
import '.jq{right:1rem;}.ssr-plugin'
import '.jr{transform:translateY(-50%);}.ssr-plugin'
import '.js{width:120px;}.ssr-plugin'
import '.jt{height:120px;}.ssr-plugin'
import '.ju{z-index:0;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.ja{z-index:1;}.ssr-plugin'
import '.s{gap:0.5rem;}.ssr-plugin'
import '.jv{max-width:calc(100% - 140px);}.ssr-plugin'
import '.jw{font-size:4rem;}.ssr-plugin'
import '.d7{font-weight:700;}.ssr-plugin'
import '.jx{line-height:100%;}.ssr-plugin'
import '.he{margin:0px;}.ssr-plugin'
import '.a2{color:var(--brand-secondary);}.ssr-plugin'
import '.a3{font-family:FunnelDisplay;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="ap l ha a b ae am e5 dm b5"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="b8 jp jq jr js jt ju a r ae"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="ap ja a b am s jv"
      >
        <div className="jw d7 jx he a2 a3"
        >
          {number}
        </div>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--brand-secondary)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
